import { useNavigate } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "../components/ui/button";

const TermsOfServicePage = () => {
  const navigate = useNavigate();

  return (
    <div className="min-h-screen bg-[#111111] text-white px-6 md:px-12 lg:px-24 py-12">
      <div className="max-w-4xl mx-auto">
        <Button
          variant="ghost"
          className="mb-6 text-zinc-400 hover:text-white"
          onClick={() => navigate("/")}
        >
          <ArrowLeft className="w-4 h-4 mr-2" />
          Back
        </Button>

        <h1 className="text-3xl md:text-4xl font-bold mb-6">Terms of Service</h1>
        <p className="text-zinc-400 mb-8">Last update: 29 April 2026</p>

        <div className="space-y-6 text-zinc-300 leading-7">
          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Service provider</h2>
            <p>SaaS-Radar (Landshut, Bayern)</p>
            <p>Contact: saas.radar.business@gmail.com</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Service scope</h2>
            <p>
              SaaS-Radar provides market opportunity insights, analytics, and product guidance features.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Account usage</h2>
            <p>
              Users are responsible for the confidentiality of their login credentials and account activity.
            </p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Payments</h2>
            <p>Payments are processed via Stripe.</p>
            <p>No refunds are provided.</p>
          </section>

          <section>
            <h2 className="text-xl font-semibold text-white mb-2">Liability</h2>
            <p>
              Insights are provided for informational and strategic support. Final business decisions remain the
              sole responsibility of the user.
            </p>
          </section>
        </div>
      </div>
    </div>
  );
};

export default TermsOfServicePage;
